import FallbackImage from '../../components/generic/FallbackImage';
import Text from '../../components/generic/Text';

import styles from './EmptyState.module.less';
import useUser from '../hooks/useUser';

const EmptyState = () => {
  const { isLoggedIn } = useUser();

  if (isLoggedIn) {
    return (
      <FallbackImage src="list-tree" alt="no published reports">
        <Text.Heading>You haven&apos;t published any SBOMs yet</Text.Heading>
        <span className={styles.message}>
          Create a release group and publish the SBOM to see it.
          This site is public. Anyone you share the URL with can view the SBOMs you publish here.
        </span>
      </FallbackImage>
    );
  }

  return (
    <FallbackImage src="no-results" alt="no published reports">
      <Text.Heading>There aren&apos;t any reports here!</Text.Heading>
      <span className={styles.message}>
        Please check back later to see if any have been published.
      </span>
    </FallbackImage>
  );
};

export default EmptyState;
